import React, { Component } from "react";
import { TimelineMax, Back } from "gsap";
import shopiteka from "../../assets/img/work/png/shopiteka.png";
import DevIcons from "./DevIcons";

class Shopiteka extends Component {
  componentDidMount() {
    this.tl = new TimelineMax({ delay: 0, ease: Back.easeOut, paused: true });
  }

  enterTransition = time => {
    this.tl.fromTo(
      this.component,
      time,
      { opacity: 0, transform: "translateX(0px)", delay: 0.5 },
      { opacity: 1, transform: "translateX(0px)" }
    );
    this.tl.play();
  };

  exitTransition = time => {
    this.tl.fromTo(
      this.component,
      time,
      { opacity: 1 },
      { transform: "translateX(-70px)", opacity: 0 }
    );
    this.tl.play();
  };

  render = () => {
    return (
      <div className="section work" ref={c => (this.component = c)}>
        <div className="workInfo">
          <div className="workImage">
            <img src={shopiteka} alt="project" />
          </div>
          <div className="title">Shopiteka</div>
          <div className="description">
            E-commerce SaaS platform shopiteka.com where people and business can
            register and create their own online shop website, complete with
            payment system integrations, shipping, drag&drop web editor, and
            many other features. It is a big ecosystem of shops, buyers,
            administration backends and transaction management. The greatest
            challenge was to cope with a size of a product, create dynamic
            website builder for all kind of devices, integrate with payment
            transaction gateways.
          </div>
          <div className="techUsed">
            <DevIcons iconList={["js", "php", "mysql"]} />
          </div>
        </div>
      </div>
    );
  };
}

export default Shopiteka;



// WEBPACK FOOTER //
// ./src/components/Work/Shopiteka.js